<template>
  <div>
    <Echart id="leftCenter" :options="options" width="100%" height="245px" v-if="pageflag" ref="charts" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      pageflag: true,
      options: {},
      timer: null
    }
  },
  props: {
  	  dataVal: {
  	        type: Object,
  	        default: () => ({})
  	      }
  },
  watch: {
  	  dataVal: {
  		  handler(newData) {
  			  this.$nextTick(() => {
  				  this.getData()
  			  })
  		  },
  		  immediate: true,
  		  deep: true
  	  }
  },
  mounted() {
    this.getData()
  },
  beforeDestroy() {
    this.clearData()
  },
  methods: {
    getData() {
      this.pageflag = true
      setTimeout(() => {
        /////////////////////////////////
   let _legendColor = '#8FD8FF';
   let _fontSize = 12;
   let _fontColor = '#8FD8FF';
   let data1 = this.dataVal.s1; 
   let data2 = this.dataVal.s2; 
   this.options =  {
    tooltip: {
        trigger: 'axis',
        axisPointer: {
            type: 'shadow'
        }
    },
    grid: {
        top: '15%',
        right: '6%',
        left: '10%',
        bottom: '20%'
    },
    xAxis: [{
        type: 'category',
        data: ['银座商城', '乐活城'],
        axisLine: {
            lineStyle: {
                color: '#FFFFFF'
            }
        },
        axisLabel: {
            margin: 10,
            color: '#e2e9ff',
            textStyle: {
                fontSize: 14
            },
        },
        axisTick: {
            show: false
        }
    }],
    yAxis: [{
        axisLabel: {
            formatter: '{value}',
            color: '#e2e9ff',
        },
        axisTick: {
            show: false
        },
        axisLine: {
            show: false,
            lineStyle: {
                color: 'rgba(0,186,255,.6)'
            }
        },
        splitLine: {
            lineStyle: {
                color: 'rgba(255,255,255,0.12)'
            }
        }
    }],
    series: [{
        type: 'bar',
        data: [data1,data2],
        barWidth: '28px',
        itemStyle: {
            normal: {
                color:new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: 'rgba(0,244,255,1)' // 0% 处的颜色
                }, {
                    offset: 1,
                    color: 'rgba(0,77,167,1)' // 100% 处的颜色
                }], false),
                shadowColor: 'rgba(0,160,221,1)',
                shadowBlur: 4,
            }
        },
        label: {
            normal: {
                show: true,
                lineHeight: 30,
                formatter: '{c}',
                position: 'top',
                textStyle: {
                    color: '#00D6F9',
                    fontSize: 20
                }

            }
        }
    }]
};

        ////////////////////////////////
      }, 500);
    },
    clearData() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
  }
}
</script>